import { useMutation, useQuery } from '@tanstack/react-query'
import useRequest from '../useRequest'
import { GET_COMPANY_CUSTOMER_VIEW_ORDERS, GET_COMPANY_CUSTOMER_CLOSE_ORDER, GET_COMPANY_CUSTOMER_OPEN_ORDER, GET_COMPANY_OPEN_ITEM, GET_COMPANY_ORDER_STATUS
  , GET_COMPANY_PURCHASE_ORDER_STATUS, GET_COMPANY_ORDER_STATUS_LIST, GET_CHANNEL_PARTNER_OENTRY_HEADER,
  GET_COMPANY_CHANNEL_PARTNER,
  GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL,
  GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_SEARCH,
  GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_AUTOCOMPLETE,

  GET_CHANNEL_PARTNER_OENTRY_HEADER_LEAD_TIME,
  POST_CHANNEL_PARTNER_OENTRY_HEADER_CART_ADD,
  GET_CHANNEL_PARTNER_OENTRY_HEADER_CART,
  GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_CANCEL,
  GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_SUBMIT,
  POST_CHANNEL_PARTNER_OENTRY_HEADER,
  DELETE_CHANNEL_PARTNER_OENTRY_HEADER_REMOVE_CART,
  PATCH_CHANNEL_PARTNER_OENTRY_HEADER_CART,
  GET_ORDER_STATUS_SO_AUTOCOMPLETE,
  GET_ORDER_STATUS_PO_AUTOCOMPLETE
 } from '../../services/URLs'
import { generatePath } from 'react-router-dom'
import StorageService from '../../services/storageService';

const QUERIES = {
  COMPANY_CUSTOMER_VIEW_ORDERS: 'COMPANY_CUSTOMER_VIEW_ORDERS',
  COMPANY_CHANNEL_PARTNER: 'COMPANY_CHANNEL_PARTNER',
  GET_COMPANY_CUSTOMER_OPEN_ORDER: 'GET_COMPANY_CUSTOMER_OPEN_ORDER',
  GET_COMPANY_CUSTOMER_CLOSE_ORDER: 'GET_COMPANY_CUSTOMER_CLOSE_ORDER',
  GET_COMPANY_OPEN_ITEM: 'GET_COMPANY_OPEN_ITEM',
  GET_COMPANY_ORDER_STATUS: 'GET_COMPANY_ORDER_STATUS',
  GET_COMPANY_PURCHASE_ORDER_STATUS: 'GET_COMPANY_PURCHASE_ORDER_STATUS',
  GET_COMPANY_ORDER_STATUS_LIST: 'GET_COMPANY_ORDER_STATUS_LIST',
  GET_CHANNEL_PARTNER_OENTRY_HEADER: 'GET_CHANNEL_PARTNER_OENTRY_HEADER',
  CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL: 'CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL',
  GET_CHANNEL_PARTNER_OENTRY_HEADER_SET_POINT: 'GET_CHANNEL_PARTNER_OENTRY_HEADER_SET_POINT',
  CHANNEL_PARTNER_OENTRY_HEADER_LEAD_TIME: 'CHANNEL_PARTNER_OENTRY_HEADER_LEAD_TIME',
  GET_CHANNEL_PARTNER_OENTRY_HEADER_CART: 'GET_CHANNEL_PARTNER_OENTRY_HEADER_CART',
  GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_SEND: 'GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_SEND',
  GET_ORDER_STATUS_SO_AUTOCOMPLETE: 'GET_ORDER_STATUS_SO_AUTOCOMPLETE',
  GET_ORDER_STATUS_PO_AUTOCOMPLETE: 'GET_ORDER_STATUS_PO_AUTOCOMPLETE',
  GET_ORDER_ENTRY_PRODUCT_SEARCH: 'GET_ORDER_ENTRY_PRODUCT_SEARCH',
  GET_ORDER_ENTRY_PRODUCT_AUTOCOMPLETE: 'GET_ORDER_ENTRY_PRODUCT_AUTOCOMPLETE',
}

const MUTATIONS = {
  POST_CHANNEL_PARTNER_OENTRY_HEADER: 'POST_CHANNEL_PARTNER_OENTRY_HEADER',
  CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL: 'CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL',
  POST_CHANNEL_PARTNER_OENTRY_HEADER_CART_ADD: 'POST_CHANNEL_PARTNER_OENTRY_HEADER_CART_ADD',
  GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_CANCEL: 'GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_CANCEL',
  GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_SUBMIT: 'GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_SUBMIT',
  DELETE_CHANNEL_PARTNER_OENTRY_HEADER_REMOVE_CART: 'DELETE_CHANNEL_PARTNER_OENTRY_HEADER_REMOVE_CART',
  PATCH_CHANNEL_PARTNER_OENTRY_HEADER_CART: 'PATCH_CHANNEL_PARTNER_OENTRY_HEADER_CART',
}

export const useGetCompanyCustomerViewOrders = () => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.COMPANY_CUSTOMER_VIEW_ORDERS],
    queryFn: async () => {
      return await request({
        method: 'get',
        url: GET_COMPANY_CUSTOMER_VIEW_ORDERS,
        config: {},
        completeResponse: false,
      });
    },
  });
};

export const useGetCompanyChannelPartner = (enabled: boolean = true) => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.COMPANY_CHANNEL_PARTNER],
    queryFn: async () => {
      return await request({
        method: 'get',
        url: GET_COMPANY_CHANNEL_PARTNER,
        config: {},
        completeResponse: false,
      });
    },
    enabled,
  });
}

export const useGetCompanyCustomerOpenOrder = (customerNumber: string | undefined, summary: boolean = false) => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.GET_COMPANY_CUSTOMER_OPEN_ORDER, customerNumber, summary],
    queryFn: async () => {
      if (!customerNumber) {
        return {};
      }
      const url = summary 
        ? `${GET_COMPANY_CUSTOMER_OPEN_ORDER}?customerNumber=${customerNumber}&summary=true`
        : `${GET_COMPANY_CUSTOMER_OPEN_ORDER}?customerNumber=${customerNumber}`;
      
      return await request({
        method: 'get',
        url: url,
        config: {},
        completeResponse: false,
      });
    },
  });
}

export const useGetCompanyCustomerCloseOrder = (customerNumber: string | undefined, summary: boolean = false) => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.GET_COMPANY_CUSTOMER_CLOSE_ORDER, customerNumber, summary],
    queryFn: async () => {
      if (!customerNumber) {
        return {};
      }
      const url = summary 
        ? `${GET_COMPANY_CUSTOMER_CLOSE_ORDER}?customerNumber=${customerNumber}&summary=true`
        : `${GET_COMPANY_CUSTOMER_CLOSE_ORDER}?customerNumber=${customerNumber}`;
      
      return await request({
        method: 'get',
        url: url,
        config: {},
        completeResponse: false,
      });
    },
  });
}

export const useGetCompanyOpenItems = (customerNumber: string | undefined) => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.GET_COMPANY_OPEN_ITEM],
    queryFn: async () => {
      // Get current user info to check access level
      const userInfo = StorageService.getUserInfo();
      const isCPUser = userInfo?.accessLevel === 'CP';
      
      // For CP users, don't pass customerNumber parameter (backend will use current user's company customer)
      // For Barksdale users, pass the customerNumber parameter as usual
      let url = GET_COMPANY_OPEN_ITEM;
      
      if (isCPUser) {
        // CP user: Don't pass customerNumber parameter
      } else {
        // Barksdale user: Pass customerNumber parameter if provided
        if (customerNumber) {
          url += `?customerNumber=${customerNumber}`;
        }
      }
      
      return await request({
        method: 'get',
        url: url,
        config: {},
        completeResponse: false,
      });
    },
  });
}

export const useGetCompanyOorderStatus = (soNumber: string | undefined) => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.GET_COMPANY_ORDER_STATUS],
    queryFn: async () => {
      if (!soNumber) {
        return {};
      }
      return await request({
        method: 'get',
        url: `${GET_COMPANY_ORDER_STATUS}?soNumber=${soNumber}`,
        config: {},
        completeResponse: false,
      });
    },
  });
}

export const useGetCompanyPurchaseOrderStatus = (poNumber: string | undefined) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_COMPANY_PURCHASE_ORDER_STATUS],
    queryFn: async () => {
      if (!poNumber) {
        return {};
      }
      return await request({
        method: 'get',
        url: `${GET_COMPANY_PURCHASE_ORDER_STATUS}?poNumber=${poNumber}`,
        config: {},
        completeResponse: false,
      });
    },
  });
}

export const useGetCompanyOrderStatusList = (soNumber?: string, poNumber?: string) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_COMPANY_ORDER_STATUS_LIST, soNumber, poNumber],
    queryFn: async () => {
      if (!soNumber && !poNumber) {
        return [];
      }
      
      const params = new URLSearchParams();
      if (soNumber) params.append('soNumber', soNumber);
      if (poNumber) params.append('poNumber', poNumber);
      
      return await request({
        method: 'get',
        url: `${GET_COMPANY_ORDER_STATUS_LIST}?${params.toString()}`,
        config: {},
        completeResponse: false,
      });
    },
    enabled: !!(soNumber || poNumber),
  });
}

;

export const useGetChannelPartnerOEntryHeader = (custNum: string | undefined) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_CHANNEL_PARTNER_OENTRY_HEADER, custNum], // oEntryAdminCustomer
    queryFn: async () => {
      return await request({
        method: 'get',
        url: GET_CHANNEL_PARTNER_OENTRY_HEADER + (custNum ? `?custNum=${custNum}` : ''),
        config: {},
        completeResponse: false,
      });
    },
  });
}

export const useGetChannelPartnerOEntryHeaderProductDetail = () => {
  const request = useRequest();
  
  return useMutation({
    mutationKey: [MUTATIONS.CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL],
    mutationFn: async (payload: any) => {
      return await request({
        method: 'get',
        url: generatePath(GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL, { partNumber: payload.partNumber }) + (payload.quantity ? `?quantity=${payload.quantity}` : ''),
        payload,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
}

export const useGetOrderEntryProductSearch = (searchTerm: string, searchType: 'exact' | 'wildcard' | 'description' = 'wildcard') => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.GET_ORDER_ENTRY_PRODUCT_SEARCH, searchTerm, searchType],
    queryFn: async () => {
      if (!searchTerm || searchTerm.trim().length === 0) {
        return { results: [], totalResults: 0 };
      }
      
      let url: string;
      if (searchType === 'description') {
        url = `${GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_SEARCH}/description?description=${encodeURIComponent(searchTerm.trim())}`;
      } else {
        url = `${GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_SEARCH}?partNumber=${encodeURIComponent(searchTerm.trim())}&searchType=${searchType}`;
      }
      
      return await request({
        method: 'get',
        url,
        config: {
          timeout: 60000, // 60 second timeout
        },
        completeResponse: false,
      });
    },
    enabled: Boolean(searchTerm && searchTerm.trim().length > 0),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2, // Retry failed requests up to 2 times
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
  });
}

export const useGetChannelPartnerOEntryHeaderProductDetails = (partNumber: string, quantity: string) => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL],
    queryFn: async () => {
      return await request({
        method: 'get',
        url: generatePath(GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_DETAIL, { partNumber: partNumber }) + (quantity ? `?quantity=${quantity}` : ''),
        config: { headers: {} },
        completeResponse: false,
      });
    },
  });
}

export const useGetChannelPartnerOEntryHeaderSetPoint = (partNumber: string) => {
  const request = useRequest();
  return useQuery({
    queryKey: ['setpoints', partNumber],
    queryFn: async () => {
      return await request({
        method: 'get',
        url: `/api/v1/channel-partners/oentry/products/${partNumber}/setpoints`,
      });
    },
    enabled: !!partNumber,
  });
}

export const useGetChannelPartnerOEntryHeaderLeadTime = (productNumber: string, partNumber: string) => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.CHANNEL_PARTNER_OENTRY_HEADER_LEAD_TIME, productNumber, partNumber],
    queryFn: async (payload: any) => {
      if (!partNumber || !productNumber) {
        return {};
      }
      return await request({
        method: 'get',
        url: generatePath(GET_CHANNEL_PARTNER_OENTRY_HEADER_LEAD_TIME, { partNumber: partNumber }),
        payload,
        config: { headers: {} },
        completeResponse: false,
      });
    },
  });
}

export const useGetChannelPartnerOEntryHeaderAddCart = () => {
  const request = useRequest();
  
  return useMutation({
    mutationKey: [MUTATIONS.POST_CHANNEL_PARTNER_OENTRY_HEADER_CART_ADD],
    mutationFn: async (payload: any) => {
      return await request({
        method: 'post',
        url: POST_CHANNEL_PARTNER_OENTRY_HEADER_CART_ADD,
        payload,
        config: { headers: {} ,},
        completeResponse: true,
      });
    },
  });
}

export const useGetChannelPartnerOEntryHeaderCart = () => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_CHANNEL_PARTNER_OENTRY_HEADER_CART],
    queryFn: async () => {
      return await request({
        method: 'get',
        url: GET_CHANNEL_PARTNER_OENTRY_HEADER_CART,
        config: {},
        completeResponse: false,
      });
    },
  });
}

export const useGetChannelPartnerOEntryHeaderCartCancel = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_CANCEL],
    mutationFn: async () => {
      return await request({
        method: 'post',
        url: GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_CANCEL,
        config: {},
        completeResponse: false,
      });
    },
  });
}

export const usePostChannelPartnerOEntryHeader = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.POST_CHANNEL_PARTNER_OENTRY_HEADER],
    mutationFn: async (payload: any) => {
      return await request({
        method: 'post',
        url: POST_CHANNEL_PARTNER_OENTRY_HEADER,
        payload,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
}

export const useGetChannelPartnerOEntryHeaderOrderSubmit = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_SUBMIT],
    mutationFn: async (payload: any) => {
      return await request({
        method: 'post',
        url: GET_CHANNEL_PARTNER_OENTRY_HEADER_ORDER_SUBMIT,
        payload,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
}

export const useDeleteChannelPartnerOEntryHeaderRemoveCart = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.DELETE_CHANNEL_PARTNER_OENTRY_HEADER_REMOVE_CART],
    mutationFn: async (payload: any) => {
      return await request({
        method: 'delete',
        url: generatePath(DELETE_CHANNEL_PARTNER_OENTRY_HEADER_REMOVE_CART, { partNumber: payload.partNumber }),
        payload,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
}

export const usePatchChannelPartnerOEntryHeaderCart = () => {
  const request = useRequest();

  return useMutation({
    mutationKey: [MUTATIONS.PATCH_CHANNEL_PARTNER_OENTRY_HEADER_CART],
    mutationFn: async (payload: any) => {
      const { quantity, requestedShipDate, comment } = payload;

      const requestData: Record<string, any> = {};
      if (quantity) {
        requestData.quantity = quantity;
      }
      if (requestedShipDate) {
        requestData.requestedShipDate = requestedShipDate;
      }
      if (comment) {
        requestData.comments = comment;
      }

      return await request({
        method: 'put',
        url: generatePath(PATCH_CHANNEL_PARTNER_OENTRY_HEADER_CART, { partNumber: payload.partNumber }),
        payload: requestData,
        config: { headers: {} },
        completeResponse: true,
      });
    },
  });
}

export const useGetOrderStatusSoAutocomplete = (prefix: string) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_ORDER_STATUS_SO_AUTOCOMPLETE, prefix],
    queryFn: async () => {
      if (!prefix || prefix.trim().length < 2) {
        return { soNumbers: [] };
      }
      
      return await request({
        method: 'get',
        url: GET_ORDER_STATUS_SO_AUTOCOMPLETE,
        config: {
          params: { prefix: prefix.trim() },
        },
        completeResponse: false,
      });
    },
    enabled: !!prefix && prefix.trim().length >= 2,
    staleTime: 5 * 60 * 1000, // 5 minutes cache
    gcTime: 10 * 60 * 1000, // 10 minutes garbage collection
  });
};

export const useGetOrderStatusPoAutocomplete = (prefix: string) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_ORDER_STATUS_PO_AUTOCOMPLETE, prefix],
    queryFn: async () => {
      if (!prefix || prefix.trim().length < 2) {
        return { poNumbers: [] };
      }
      
      return await request({
        method: 'get',
        url: GET_ORDER_STATUS_PO_AUTOCOMPLETE,
        config: {
          params: { prefix: prefix.trim() },
        },
        completeResponse: false,
      });
    },
    enabled: !!prefix && prefix.trim().length >= 2,
    staleTime: 5 * 60 * 1000, // 5 minutes cache
    gcTime: 10 * 60 * 1000, // 10 minutes garbage collection
  });
};

export const useGetOrderEntryProductAutocomplete = (prefix: string) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_ORDER_ENTRY_PRODUCT_AUTOCOMPLETE, prefix],
    queryFn: async () => {
      if (!prefix || prefix.trim().length < 2) {
        return { partNumbers: [] };
      }

      return await request({
        method: 'get',
        url: GET_CHANNEL_PARTNER_OENTRY_HEADER_PRODUCT_AUTOCOMPLETE,
        config: {
          params: {
            prefix: prefix.trim(),
          },
        },
        completeResponse: false,
      });
    },
    enabled: Boolean(prefix && prefix.trim().length >= 2),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};